import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>UNSUBSCRIBE_CHANNEL</h1>
        </div>
        <p>
          Emit this socket event to leave a space and cease to receive socket
          events related to it.
        </p>
        <h2>Payload Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>channel</td>
                <td>
                  Space details.
                  <ul>
                    <li>
                      <em>type</em>: (string) 'topic'
                    </li>
                    <li>
                      <em>_id</em>: (string) unique identifier of the space
                    </li>
                  </ul>
                </td>
                <td>Object</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authorization</h2>
        <p>Subscribed to the channel.</p>
        <h2>Example</h2>
        <pre className="javascript">
          socketConnection.emit('UNSUBSCRIBE_CHANNEL', payload);
        </pre>
        <h4>Payload</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"    "}"channel": {"{"}
          {"\n"}
          {"        "}"type": "topic",{"\n"}
          {"        "}"_id": "594140a11d108619100a7363"{"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"}"}
        </pre>
      </div>
    </div>
  </Layout>
)
